export default __webpack_public_path__ + "static/media/AdventureFeed.c589e9a4.jpeg";